<template>
<div>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>

    <b-table-simple v-else hover responsive>
        <b-thead>
            <b-th> {{$t('account.tracing.name')}} </b-th>
            <b-th> {{$t('account.tracing.tracking')}} </b-th>
            <b-th> {{$t('account.tracing.state')}} </b-th>
        </b-thead>
        <b-tbody>
            <b-tr v-for="track in tracings" :key="track.id">
                <b-th> {{track.control_info && track.control_info.name}} </b-th>
                <b-td> 
                    <b-icon v-if="track.is_control" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> 
                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                </b-td>
                <b-td> 
                    <b-button v-if="track.is_control" variant="outline-danger" @click="changeState(false, track.id)"> {{$t('account.tracing.stopTracking')}} </b-button> 
                    <b-button v-else variant="outline-success" @click="changeState(true, track.id)"> {{$t('account.tracing.startTracking')}}  </b-button> 
                </b-td>
            </b-tr>
            
        </b-tbody>
    </b-table-simple>
    </div>
</template>

<script>
    export default {
        name: "TracingForm",
        props: {
            modalEvent: { type: Function },
            modalType: { type: Function }
        },
        methods:{
            changeState: async function(status, id){
                let data = {
                    accountId: this.$store.getters.accountId ? this.$store.getters.accountId.data : this.$route.params.id ,
                    id,
                    state: status
                }
                await this.$store.dispatch('updateTracings', data)
                await  this.$store.dispatch('getTracings',data)
            }
        },
        computed: {
            accountId(){
                return this.$store.getters.accountId
            },
            tracings(){
                return this.$store.getters.getTracings
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/Tracing.vue